import { Link } from "wouter";
import type { LocationCtx } from "./location-data";

/** Plain text only: React escapes labels and existing links are never nested. */
export function AreaText({ text, ctx }: { text: string; ctx: LocationCtx }) {
  const entries = Object.entries(ctx.areaLinks || {}).filter(([, href]) => /^\/[a-z0-9][a-z0-9/_-]*$/i.test(href));
  if (!entries.length) return <>{text}</>;
  const lookup = new Map(entries.map(([name, href]) => [name.toLowerCase(), href]));
  const names = entries.map(([name]) => name).sort((a, b) => b.length - a.length)
    .map(name => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const pattern = new RegExp(`(?<![\\p{L}\\p{N}])(${names.join("|")})(?![\\p{L}\\p{N}])`, "giu");
  return <>{text.split(pattern).map((part, index) => index % 2 === 1
    ? <Link key={index} href={lookup.get(part.toLowerCase())!} className="underline decoration-current/40 underline-offset-4 hover:decoration-current focus-visible:outline focus-visible:outline-2">{part}</Link>
    : part)}</>;
}
